<nav class="nav-wrapper">
    <div class="nav-bar">
        <div class="left">
            <div class="nav-brand" (click)="onClickLogo()">
                <app-svg-loader height="20px" url="assets/logos/tail-one-logo-mono-white.svg"></app-svg-loader>
                <div class="admin-label">Administrative Tools</div>
            </div>
            <div class="admin-links">
                <a routerLink="/admin/hq" routerLinkActive="active">HQ</a>
                <a routerLink="/admin/flights" routerLinkActive="active">Flights</a>
                <a routerLink="/admin/review-memberships" routerLinkActive="active">Reviews</a>
            </div>
        </div>
        <div class="right">
            <app-nav-user-widget></app-nav-user-widget>
        </div>
    </div>
</nav>
